/* eslint-disable prefer-const */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-useless-escape */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { jwtDecode } from 'jwt-decode';

import {
 removeConfigStorageItem,
 setConfigStorageItem,
} from '../hooks/useConfigStorage';
import {
 deleteCookieCustom,
 getCookieCustom,
 setCookieCustom,
} from '../utils/cookies';
import { JWTTokenDTO } from '../redux/identity/identityTypes';

const axiosConfig = {
 baseURL: import.meta.env.VITE_API_URL,
 timeout: 10000,
 headers: {
  'Content-Type': 'application/json',
 },
};

export const axiosInstance = axios.create(axiosConfig);

export const get = (url: string) => axiosInstance.get(url);
export const post = (url: string, data: any) => axiosInstance.post(url, data);
export const put = (url: string, data: any) => axiosInstance.put(url, data);
export const del = (url: string, data?: any) =>
 axiosInstance.delete(url, { data });
export const patch = (url: string, data: any) => axiosInstance.patch(url, data);

export default { get, post, put, del, patch };

// Add a request interceptor
axiosInstance.interceptors.request.use(
 (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  const accessTokenCookie = getCookieCustom('access_token');
  //   console.log(config.data instanceof FormData, typeof config.data, config);
  let contentType = 'application/json';
  if (
   config.data instanceof FileList ||
   config.data instanceof FormData ||
   (typeof config.data === 'object' && 'uploads' in (config.data || {}))
  ) {
   contentType = 'multipart/form-data';
  }
  if (config.method === 'patch') {
   contentType = 'application/json-patch+json';
  }

  if (
   accessTokenCookie &&
   accessTokenCookie !== 'fail' &&
   config.url !== '/Identity/v1/login'
  ) {
   config.headers.set('Content-Type', contentType);
   config.headers.set('Authorization', `Bearer ${accessTokenCookie}`);
  } else {
   config.headers.set('Content-Type', contentType);
  }
  return config;
 },
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
 (response: AxiosResponse<JWTTokenDTO>) =>
  // Any status code that lie within the range of 2xx cause this function to trigger
  {
   if (
    response.config.url === '/Identity/v1/login' &&
    response.status === 200 &&
    response.data.access_token &&
    response.data.refresh_token &&
    response.data.expiration &&
    !response.data.requires2FA
   ) {
    // test
    // const decoded = jwtDecode(response.data.access_token);
    // cookie set was put in identityLoginSaga
   }
   return response;
  },
 async (error) => {
  // TODO: remove duplicate login if more than 1 api call
  let originalRequest = error.config;
  //   console.log(originalRequest._retry);
  if (error?.response?.status === 401 && !originalRequest._retry) {
   //    console.log(JSON.stringify(originalRequest));
   originalRequest._retry = true; // Mark the request as retried to avoid infinite loops.
   try {
    const accessTokenCookie = getCookieCustom('access_token');
    const refreshTokenCookie = getCookieCustom('refresh_token');
    let response;

    if (
     originalRequest.url === '/Identity/v1/login' &&
     (!accessTokenCookie || !refreshTokenCookie)
    ) {
     console.log('wrong credentials');
    } else if (!accessTokenCookie || !refreshTokenCookie) {
     window.location.href = '/login';
     //  response = await axios.post(
     //   '/Identity/v1/login',
     //   JSON.stringify({
     //    email: 'daniil.mikenas@gmail.com',
     //    password: 'Ux6kUQjzrZHxAg1d',
     //   }),
     //   axiosConfig,
     //  );
    } else {
     console.log('token refresh');
     response = await axios.post(
      '/Identity/v1/refresh-token',
      {
       access_token: accessTokenCookie,
       refresh_token: refreshTokenCookie,
      },
      axiosConfig,
     );

     const {
      access_token: accessTokenNew,
      refresh_token: refreshTokenNew,
      expiration: expirationNew,
      configuration: configurationNew,
     } = response.data;

     const decoded = jwtDecode(accessTokenNew);
     // Store the new access and refresh tokens.
     setCookieCustom('access_token', accessTokenNew, expirationNew);
     setCookieCustom('refresh_token', refreshTokenNew, expirationNew);
     setCookieCustom('expiration', expirationNew, expirationNew);
     setCookieCustom('user_id', (decoded as any)?.userId, expirationNew);
     setConfigStorageItem({
      key: 'configuration',
      value: JSON.stringify(configurationNew),
     });

     // Update the authorization header with the new access token.
     axiosInstance.defaults.headers.common.Authorization = `Bearer ${accessTokenNew}`;
     return await axiosInstance(originalRequest); // Retry the original request with the new access token.
    }
   } catch (refreshError) {
    console.error('Token refresh failed:', refreshError);
    deleteCookieCustom('access_token', '/');
    deleteCookieCustom('refresh_token', '/');
    deleteCookieCustom('expiration', '/');

    removeConfigStorageItem({
     key: 'configuration',
    });
    window.location.href = '/login';
    return Promise.reject(refreshError);
   }
  }
  return Promise.reject(error); // For all other errors, return the error as is.
 },
);
